"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;

var _react = _interopRequireWildcard(require("react"));

var _util = require("../util");

var _primitives = require("@bedrock-layout/primitives");

var _excluded = ["src", "thumbnail", "children", "absoluteChildren", "className"],
    _excluded2 = ["curTime", "setCurTime", "duration", "videoRef", "src"],
    _excluded3 = ["curTime", "setCurTime", "duration", "videoRef", "src"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Video = function Video(props) {
  var videoRef = (0, _react.useRef)();
  var progressState = Video.Progress.useState({
    videoRef: videoRef,
    src: props.src
  });
  return /*#__PURE__*/_react.default.createElement(Video.Container, _extends({
    ref: videoRef
  }, props), /*#__PURE__*/_react.default.createElement(Video.PlayButton, {
    autoPlay: props.autoPlay
  }), /*#__PURE__*/_react.default.createElement(Video.Progress.Text, progressState), /*#__PURE__*/_react.default.createElement(Video.Progress.Bar, progressState), /*#__PURE__*/_react.default.createElement(Video.Loop, null), /*#__PURE__*/_react.default.createElement(Video.Fullscreen, null), /*#__PURE__*/_react.default.createElement(Video.Download, null));
};

exports.Video = Video;
Video.Container = /*#__PURE__*/_react.default.forwardRef(function (_ref, fwVideoRef) {
  var src = _ref.src,
      thumbnail = _ref.thumbnail,
      children = _ref.children,
      absoluteChildren = _ref.absoluteChildren,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var videoRef = (0, _util.useForwardedRef)(fwVideoRef);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'mediaRoot ' + className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "absoluteContainer"
  }, /*#__PURE__*/_react.default.createElement("video", _extends({
    ref: videoRef,
    src: src,
    controls: false,
    poster: thumbnail,
    playsInline: true
  }, props)), _react.default.Children.map(absoluteChildren, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      videoRef: videoRef,
      src: src
    });
  }), /*#__PURE__*/_react.default.createElement(_primitives.Inline, {
    className: "controlBar",
    gutter: "2%",
    align: "center"
  }, _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      videoRef: videoRef,
      src: src
    });
  }))));
});

Video.Fullscreen = function (_ref2) {
  var videoRef = _ref2.videoRef,
      src = _ref2.src;

  var _useState = (0, _react.useState)(document.fullscreen),
      _useState2 = _slicedToArray(_useState, 2),
      fullscreen = _useState2[0],
      setFullscreen = _useState2[1];

  var toggle = (0, _react.useCallback)(function () {
    if (videoRef) setFullscreen((0, _util.toggleFullscreen)(videoRef.current.parentNode.parentNode));
  }, [videoRef]);
  return (0, _util.fullScreenEnabled)() && /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-".concat(fullscreen ? "minimize" : "maximize"),
    onClick: toggle
  });
};

Video.Download = function (_ref3) {
  var videoRef = _ref3.videoRef,
      src = _ref3.src;
  return /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-download",
    onClick: function onClick() {
      window.open(src, "_blank");
    }
  });
};

Video.Loop = function (_ref4) {
  var videoRef = _ref4.videoRef,
      src = _ref4.src;

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loop = _useState4[0],
      setLoop = _useState4[1];

  var playAgain = function playAgain() {
    if (loop) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  (0, _util.useRefListener)(videoRef, 'ended', playAgain, [src, loop]);
  return /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-sync-alt",
    onClick: function onClick() {
      return setLoop(function (loop) {
        return !loop;
      });
    },
    style: loop ? {} : {
      color: '#888'
    }
  });
};

Video.PlayButton = function (props) {
  var videoRef = props.videoRef,
      src = props.src,
      _props$autoPlay = props.autoPlay,
      autoPlay = _props$autoPlay === void 0 ? false : _props$autoPlay;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      playing = _useState6[0],
      setPlaying = _useState6[1]; // whenever a new source is loaded, try to autoPlay


  (0, _react.useEffect)(function () {
    if (autoPlay) {
      var _videoRef$current;

      (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.play().then(function () {
        return setPlaying(true);
      }).catch(function () {
        return setPlaying(false);
      });
    } else {
      setPlaying(false);
    }
  }, [src, videoRef.current]); // @Cleanup: probably not .current
  // also toggle play on clicking the video

  var toggle = function toggle() {
    return setPlaying(function (p) {
      return !p;
    });
  };

  (0, _util.useRefListener)(videoRef, 'click', toggle, [src]); // sync playing state with video element

  (0, _react.useLayoutEffect)(function () {
    // LayoutEffect is nescesary for safari https://lukecod.es/2020/08/27/ios-cant-play-youtube-via-react-useeffect/
    if (!videoRef.current) return;

    if (playing && videoRef.current.paused) {
      videoRef.current.play().catch(function () {
        return setPlaying(false);
      });
    } else if (!playing && !videoRef.current.paused) {
      videoRef.current.pause();
    }
  }, [videoRef, playing]);
  return playing ? /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-pause",
    onClick: function onClick() {
      return setPlaying(false);
    }
  }) : /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-play",
    onClick: function onClick() {
      return setPlaying(true);
    }
  });
};

Video.Progress = {
  useState: function useState(_ref5) {
    var videoRef = _ref5.videoRef,
        src = _ref5.src;

    var _useState8 = (0, _react.useState)(0),
        _useState9 = _slicedToArray(_useState8, 2),
        curTime = _useState9[0],
        setCurTime = _useState9[1];

    var _useState10 = (0, _react.useState)(0),
        _useState11 = _slicedToArray(_useState10, 2),
        duration = _useState11[0],
        setDuration = _useState11[1];

    function updateTimes() {
      var _videoRef$current2, _videoRef$current3;

      setCurTime(((_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.currentTime) || 0);
      setDuration(((_videoRef$current3 = videoRef.current) === null || _videoRef$current3 === void 0 ? void 0 : _videoRef$current3.duration) || 0);
    }

    (0, _util.useRefListener)(videoRef, 'loadedmetadata', updateTimes); // init on newly loaded videos

    (0, _util.useRefListener)(videoRef, 'timeupdate', updateTimes); // update state on all timeupdate events

    return {
      curTime: curTime,
      setCurTime: setCurTime,
      duration: duration
    };
  },
  Text: function Text(_ref6) {
    var curTime = _ref6.curTime,
        setCurTime = _ref6.setCurTime,
        duration = _ref6.duration,
        videoRef = _ref6.videoRef,
        src = _ref6.src,
        props = _objectWithoutProperties(_ref6, _excluded2);

    return /*#__PURE__*/_react.default.createElement("span", _extends({
      className: "progressText"
    }, props), (0, _util.toHHMMSS)(curTime), "\u2009/\u2009", (0, _util.toHHMMSS)(duration));
  },
  Bar: function Bar(_ref7) {
    var curTime = _ref7.curTime,
        setCurTime = _ref7.setCurTime,
        duration = _ref7.duration,
        videoRef = _ref7.videoRef,
        src = _ref7.src,
        props = _objectWithoutProperties(_ref7, _excluded3);

    var progressRootRef = (0, _react.useRef)();
    var rect = (0, _util.useBoundingBox)(progressRootRef);

    var getSeekTime = function getSeekTime(e) {
      var clickX = e.touches ? e.touches[0].clientX : e.clientX; // subtract rect.height/2 of buffer to each side, so you can actually seek to the beginning/end

      var seekFraction = (0, _util.clamp)((clickX - rect.x - rect.height / 2) / (rect.width - rect.height), 0, 1);

      var seekTime = function seekTime(seekFrac) {
        return seekFrac * duration || 0;
      };

      return seekTime(seekFraction);
    };

    var seek = function seek(e) {
      var video = videoRef.current;
      var seekTime = getSeekTime(e);
      setCurTime(seekTime);
      if (video.fastSeek) video.fastSeek(seekTime);else video.currentTime = seekTime;
    };

    var mouseMove = function mouseMove(e) {
      if (e.buttons == 1) seek(e);
    };

    return /*#__PURE__*/_react.default.createElement("div", _extends({
      className: "progressBar",
      ref: progressRootRef
    }, props, {
      onMouseMove: mouseMove,
      onTouchMove: seek,
      onClick: seek
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "bar",
      style: {
        width: "".concat(!rect ? 0 : curTime / duration * (rect.width - rect.height), "px")
      }
    }));
  }
};